// #region Dependencias
import styled from 'styled-components'
import { colors } from 'components/Library/theme'
// #endregion

// #region Estilos
const StyledCardFooter = styled.div`
  align-items: ${({ alignItems = 'center' }) => alignItems};
  border-top: 1px solid ${colors.light};
  display: flex;
  flex-direction: ${({ flexDirection = 'row' }) => flexDirection};
  justify-content: ${({ justifyContent = 'center' }) => justifyContent};
  padding: 1rem;
`
// #endregion

/**
 * Componente para renderizar el footer de una tarjeta.
 *
 * @class
 * @example
 * <Card>
 *  ...
 *  <CardFooter>...</CardFooter>
 * </Card>
 *
 * @param {Object} props - Propiedades del componente.
 * @param {string} [props.alignItems="center"] - Atributo 'align-items'.
 * @param {string} [props.flexDirection="row"] - Atributo 'flex-direction'.
 * @param {string} [props.justifyContent="center"] - Atributo 'justify-content'.
 * @param {React.ReactNode} props.children - Contenido que será renderizado dentro del componente.
 */
const CardFooter = ({ children, ...props }) => {
  return <StyledCardFooter {...props}>{children}</StyledCardFooter>
}

export default CardFooter
